<template>
    <div class="card shadow-none bg-transparent  border-primary">
        <div class="card-body pb-50" style="position: relative;">
            <h6 class="text-h6 text-primary">
                {{ localizationStore.translate('ssc.image.label') }}
            </h6>
            <div class="form-group d-flex flex-column">
                <form class="driver-state-form">
                    <!-- <p v-if="allowImageUpload == null" class="text-primary mb-1 font-weight-bolder">{{ errorMessage }}</p>-->
                    <p v-if="allowImageUpload == false" class="text-danger mb-1 font-weight-bolder">{{ errorMessage }}</p> 
                    <label for="social_security_card" id="upload_label"> Choose Image </label>
                    <input
                        type="file"
                        class="py-1"
                        id="social_security_card"
                        name="identity_image"
                        value=""
                        @change="onchangeImage"
                        style="display:none"
                        ref="inputfile"
                    />
                    <input type="hidden" value="identity_image" name="image-type" />
                </form>
            </div>

            <div class="row driver-image">
                <div class="m-auto  image-container" style="position:relative">
                    <img
                        :src="image"
                        class="image-fluid"
                        v-if="image != null"
                    />
                    <div class="image-delete" @click.prevent="showDeleteAlert" v-if="deleteFile != false">Delete</div>
                    <div class="image-upload-loader" v-if="imageUploading"><p>Uploading Image...</p></div>
                </div>
            </div>

        </div>
    </div>
    <sweet-delete-alert v-if="allowDelete">
        <template #actionsBtn>
            <div class="swal2-actions">
                <div class="swal2-loader"></div>
                <button type="button" class="swal2-confirm btn btn-primary" style="disp2lay: inline-block;" aria-label="" v-on:click="deleteImage()">Yes, Delete Image</button>
                <button type="button" class="swal2-deny mr-10" style="display: none;" aria-label="">No</button>&nbsp;&nbsp;&nbsp;
                <button type="button" class="swal2-cancel btn btn-outline-danger ms-1" style="display: inline-block;" aria-label="sweetAlertDelete" @click="showDeleteAlert()">Cancel</button>
            </div>
        </template>
    </sweet-delete-alert>
    <drop-image-model v-if="viewCropperModel">
        <template #saveCancel>
            <button type="button"  class="btn btn-primary mr-sm-1 mb-1 mb-sm-0" @click.once="userStore.saveCroppedImage($e,type = 'ssn_image'),showCropperModel()" :key="userStore.keySaves">Save</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="closeCropper">Cancel</button>
        </template>
    </drop-image-model>
</template>
<script>
import { ref, toDisplayString } from 'vue'
import { useLocalizationStore } from '../../../../stores/LocalizationStore.js'
import { useUserStore } from '../../../../stores/UserStore.js'
import SweetDeleteAlert from '../../Components/SweetDeleteAlert.vue'
export default{
    components:{
        SweetDeleteAlert
    },
    props:{

    },
    setup(){
        const team = ref(null),
        client = ref(null),
        imageSaveUrl = ref(null),
        imageDeleteUrl = ref(null),
        imageFile = ref(),
        image = ref(),
        deleteFile = ref(false),
        allowsave = ref(false),
        originalImage = ref(null),
        imageUploading = ref(false),
        allowDelete = ref(false),
        allowImageUpload = ref(null),
        errorMessage = ref('Upload image size Must be 1mb or less'),
        image_size= process.env.MIX_IMAGE_SIZE;
        return {
            localizationStore:useLocalizationStore(),
            userStore:useUserStore(),
            client,
            team,
            image,
            imageSaveUrl,
            imageFile,
            imageDeleteUrl,
            deleteFile,
            allowDelete,
            allowsave,
            originalImage,
            imageUploading,
            allowImageUpload,
            errorMessage,
            image_size,
            viewCropperModel:ref(false)
        }
    },
    watch: {
        async 'userStore.user' (value) {
            this.image = value.ssn_image_url
            this.previousImage = value.ssn_image_url
            if(value.ssn_image_url != null){
                this.deleteFile = true
            }

            if (value.isClient && !this.$route.params.team) {
                let params = {};
                params.client = value.id;
                if (this.userStore.user.id) {
                    params.client = this.userStore.user.id;
                }
                const saveImageRoute = this.$router.resolve(
                    {
                        name: 'image-save',
                        params: params
                    }
                );
                const deleteImageRoute = this.$router.resolve(
                    {
                        name: 'image-delete',
                        params: params
                    }
                );
                this.imageSaveUrl = saveImageRoute.href
                this.imageDeleteUrl = deleteImageRoute.href
            }

        },
        async 'userStore.img' (value) {
            if(this.userStore.imgChanged.ssn_image == true){
                this.image = value
                this.allowsave = true
            }else{
                this.image = this.previousImage
                this.allowsave = false
            }
            if(value == null){
                this.$refs.inputfile.value = ""
            }
        },
        async 'userStore.imgChanged.ssn_image' (value) {
            if(value == false){
                this.image = this.previousImage
                this.allowsave = false
            }
        },
        async 'image' (value) {
            if(!_.isNull(value) && this.userStore.saveType == 'ssn_image'){
                this.saveImage()
            }
        },
    },
    mounted(){
        if(this.$route.matched.some(({ name }) => name === 'diy-dashboard')){
            this.imageSaveUrl = this.$router.resolve({name: 'image-save'}).href;
            this.imageDeleteUrl = this.$router.resolve({name: 'image-delete'}).href;
        }else{
            let params = {};
            if (this.$route.params && this.$route.params.client) {
                params.client = this.$route.params.client;
            }
            if (this.$route.params && this.$route.params.team) {
                params.team = this.$route.params.team;
            }
            if (this.userStore.user.id) {
                params.client = this.userStore.user.id;
            }
            let $this = this;
            this.team = params.team;
            this.client = params.client;
            const saveImageRoute = this.$router.resolve(
                {
                    name: 'image-save',
                    params: params
                }
            );
            const deleteImageRoute = this.$router.resolve(
                {
                    name: 'image-delete',
                    params: params
                }
            );
            this.imageSaveUrl = saveImageRoute.href
            this.imageDeleteUrl = deleteImageRoute.href
        }
        if(!_.isNull(this.userStore.user)){
            this.image = this.userStore.user.ssn_image_url
            this.previousImage = this.userStore.user.ssn_image_url

            if(this.userStore.user.ssn_image_url != null){
                this.deleteFile = true
            }
            if(this.userStore.imgChanged.ssn_image == true){
                this.allowsave = true
            }else{
                this.allowsave = false
            }
            if(this.userStore.img == null){
                this.$refs.inputfile.value = ""
            }
        }
    },
    methods: {
        showCropperModel(){
            this.viewCropperModel = !this.viewCropperModel;
        },
        closeCropper(){
            this.viewCropperModel = false;
            this.userStore.imgChanged.ssn_image = false
            this.userStore.imgChanged.address_verification_image = false
            this.userStore.imgChanged.lincence_state_image = false
            this.userStore.img = null
        },
        onchangeImage(e){
            const file = e.target.files[0];
            const fileType = file.type;
            if(!fileType.startsWith('image/')){
                this.allowImageUpload = false,
                this.errorMessage = 'Selected File Is Not An Image,Please Select An Image File.';
            }else{
                this.originalImage = file
                this.userStore.img = URL.createObjectURL(file);
                this.userStore.imageType = fileType;
                this.userStore.imgChanged.ssn_image = true;
                this.userStore.imgChanged.address_verification_image = false;
                this.userStore.imgChanged.lincence_state_image = false;
                this.allowsave = true,
                this.allowImageUpload = null,
                this.showCropperModel();
            }
        },
        saveImage(){
            let data = new FormData();
            data.append('image-type', 'ssn_image');
            data.append('ssn_image',  this.originalImage);
            data.append('ssn_image_cropped',  this.image);
            data.append('crop',  true);
            this.imageUploading = true;
            if(!_.isEmpty(this.image)){
                axios.post(this.imageSaveUrl,data).then(({data})=>{
                    if(data.error != true){
                        toastr.success(data.message,'Image Uploaded');
                        this.previousImage = data.data.url
                        this.image = data.data.url
                        this.deleteFile = true
                        this.allowsave = false
                        this.userStore.imgChanged.ssn_image = false;
                        this.imageUploading = false;
                        this.userStore.saveType = null
                    }else{
                        toastr.error(data.message,'Image Upload');
                    }
                    this.allowsave = false
                    this.imageUploading = false;

                })
            }

        },
        showDeleteAlert(){
            if(this.allowDelete == false){
                this.allowDelete = true
            }else{
                this.allowDelete = false
            }
        },
        deleteImage(){
            const params = {
                'image-type':'ssn_image',
                'image-cropped-type':'ssn_image_cropped'
            }
            axios.post(this.imageDeleteUrl,params).then(({data})=>{
                if(data.error != true){
                    toastr.success(data.message,'Image Deleted');
                    this.image = null
                    this.deleteFile = false
                    this.allowDelete = false
                    this.previousImage = null

                }else{
                    toastr.error(data.message,'Image Deleted');
                }
            })
        }
    },
}
</script>
